<template>
  <div class="flex px-4">
    <div class="flex-1">
      <span>
        {{ period }}
      </span>
    </div>
    <div class="flex-1 text-center">
      <span>
        {{ impressions | thousands }}
      </span>
    </div>
    <div class="flex-1 text-center">
      <span>
        {{ reach | thousands }}
      </span>
    </div>
    <div class="flex-1 text-center">
      <span>
        {{ frequency.toFixed(1) }}
      </span>
    </div>
    <div class="flex-1 text-center">
      <span>
        {{ inlineLinkClicks | thousands }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    period: { type: String, required: true },
    impressions: { type: Number, required: true },
    reach: { type: Number, required: true },
    frequency: { type: Number, required: true },
    inlineLinkClicks: { type: Number, required: true },
  },
};
</script>
